import { AutenticationService } from './../../service/autentication/autentication.service';
import { Router } from '@angular/router';
import { MasterDataManagementService } from 'src/app/shared/service/master-data-management/master-data-management.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FirebaseService } from '@service/firebase/firebase.service';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-programme',
  templateUrl: './programme.component.html',
  styleUrls: ['./programme.component.css']
})
export class ProgrammeComponent implements OnInit {
  @Input() userInfo: any;
  @Output() closePopUpCLick: EventEmitter<any> = new EventEmitter<any>();
  programList;
  cohortId: any;
  programList_filtered: any = [];
  userMappedProgramList: any;

  constructor(public masterDataManagementService: MasterDataManagementService, public router: Router,
              public autenticationService: AutenticationService,
            public fireBaseService: FirebaseService) {
    this.cohortId = this.masterDataManagementService.getProgramFromLocalStorage();
  }

  ngOnInit(): void {
    this.programList = new DataSource({ store: this.userInfo?.program_cohort ?? [],
        group: "program"})
  }

  cohortOptionChange(e) {
    this.cohortId = e.value;
  }

  onFormSubmit(e) {
    if (this.cohortId){
      this.autenticationService.setUserDataOnLocalStorageObs(true);
      const program = this.userInfo.program_cohort.find((x) => String(x.cohort_id) === this.cohortId)
      this.masterDataManagementService.setProgramInLocalStorage(program.program_id);
      this.masterDataManagementService.setCohortInLocalStorage(this.cohortId)
      this.masterDataManagementService.setwebACLTriggerObs(true);
      this.fireBaseService.setNotificationLoadObs(true);
      this.router.navigateByUrl('/dashboard');
      this.closePopUpCLick.emit();
    }
  }
}
